// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/components/Footer/footer.scss
// module id = 618
// module chunks = 0